import { useContext } from "react";
import "./AppleCoverage.scss";
import {Typography } from "mobily-ui-library";
import AddLogo from "../../assets/Vector.svg";
import AppleCareCardLogo from "../../assets/AppleCareLogo.svg";
import InfoLogo from "../../assets/Info.svg";
import { t } from "i18next";
import CloseIcon from "../../assets/closeIcon.svg";
import { GlobalContext } from "../../context/GlobalContext";

interface Props {
  handleOpenInfoModal?: (val: any) => void | undefined;
  rtl?:boolean;
}

const AppleCoverage = ({
  handleOpenInfoModal,
  rtl
}: Props) => {

  const { state }: any = useContext(GlobalContext);
    const { appleCareApplied, selectedAcPlan, scData } = state;
    const appleCare = scData?.offerContainer[0].cartItem?.filter((item: any) => {
      if (item?.product?.name.includes("AppleCare+ warranty one time")) {
          return item;
      } else if (item?.product?.name.includes("AppleCare+ warranty recurring")) {
          return item;
      }
  })?.[0];

  const acPrice = appleCare?.itemTotalPrice?.[0]?.price?.taxIncludedAlteredAmount?.value;
    const coverageText = selectedAcPlan?.acName?.includes("AppleCare+ warranty recurring") ?
     t("monthly_coverage_added_text", { ac_monthly_amount: acPrice }) : t("yearly_coverage_added_text", { ac_yearly_amount: acPrice })
  
  return (
    <>
       <div className="AppleCareCoverageContainer">
              <div className="AppleCareTextContent">
                <div className="AppleCareText">
          <div className="appleCareLogo" >
            <img src={AppleCareCardLogo} alt="apple logo" className="AppleLogo"/>
          </div>

                <div className="AppleCareTextHeader" style={{margin:rtl?'0px 8px':''}}>
                    <Typography>{t("Add_AppleCare_coverage")}</Typography>
                </div>
                
              <div className="InfoLogocontent" onClick={()=>{handleOpenInfoModal?.("info")}}>
            <img src={InfoLogo} alt="apple-damage" className="InfoLogo"/>
              </div>
                </div>
                <div className="AppleCareText">
                <div className="AppleCareTextDescription">
                    <Typography>{appleCareApplied? coverageText : t("InfoModalMessage")}</Typography>
                </div>
                </div>
              </div>
              <div className="AddLogocontent" onClick={()=>{handleOpenInfoModal?.("icon")}}>
            <img src={ appleCareApplied ? CloseIcon: AddLogo } alt="apple add logo" className="AddLogo_Info"/>
              </div>
            </div>
    </>
  );
};
export default AppleCoverage;